/**
 * Collection page: enforce filter.v.availability=1 in URL,
 * hide "In stock" from active facets and from filter accordion,
 * adjust facet-count (minus one or clear when 1).
 */
(function () {
  if (!window.FoxTheme || !FoxTheme.collectionAvailabilityFilter || !FoxTheme.collectionAvailabilityFilter.isCollectionPage) {
    return;
  }

  const config = FoxTheme.collectionAvailabilityFilter;
  const availabilityParam = config.availabilityParam;
  const inStockLabel = config.inStockLabel;
  const drawerIndex = config.availabilityFilterIndexDrawer;
  const verticalIndex = config.availabilityFilterIndexVertical;

  function ensureAvailabilityInUrl() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('filter.v.availability') === '1') return false;
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page');

    var form = document.querySelector('form[is="facet-form"]');
    if (form && typeof form.renderSection === 'function' && window.FoxTheme && window.FoxTheme.utils && typeof window.FoxTheme.utils.getSectionId === 'function') {
      url.searchParams.set('section_id', window.FoxTheme.utils.getSectionId(form));
      window.history.replaceState(null, '', url.toString());
      form.renderSection(url.toString());
      return true;
    }
    window.location.replace(url.toString());
    return true;
  }

  function applyAvailabilityFilterHiding() {
    const activeContainer = document.getElementById('FacetFiltersActive');
    if (activeContainer) {
      const facets = activeContainer.querySelectorAll('a.facet-remove');
      facets.forEach(function (link) {
        const titleEl = link.querySelector('.facet-title');
        if (!titleEl) return;
        const text = (titleEl.textContent || '').trim();
        if (text === inStockLabel) {
          link.style.setProperty('display', 'none');
        }
      });
    }

    const facetCounts = document.querySelectorAll('.facet-drawer-wrapper facet-count');
    facetCounts.forEach(function (el) {
      const raw = (el.textContent || '').trim();
      const match = raw.match(/\((\d+)\)/);
      const num = match ? parseInt(match[1], 10) : 0;
      if (num === 1) {
        el.textContent = '';
        el.setAttribute('hidden', '');
      } else if (num > 1) {
        const newNum = num - 1;
        el.textContent = '(' + newNum + ')';
        el.removeAttribute('hidden');
      }
    });

    const accordionsToHide = document.querySelectorAll(
      '.accordion-details.facet-accordion-details[data-index="' + drawerIndex + '"], .accordion-details.facet-accordion-details[data-index="' + verticalIndex + '"]'
    );
    accordionsToHide.forEach(function (el) {
      el.style.setProperty('display', 'none');
    });
  }

  function init() {
    // TODO: Return Availability
    // var didRedirectOrFetch = ensureAvailabilityInUrl();
    // if (!didRedirectOrFetch) {
    //   applyAvailabilityFilterHiding();
    // }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, function () {
      setTimeout(applyAvailabilityFilterHiding, 0);
    });
  }

  window.addEventListener('popstate', function () {
    if (new URL(window.location.href).searchParams.get('filter.v.availability') === '1') {
      applyAvailabilityFilterHiding();
    }
  });
})();
